export default {
  body: document.querySelector('body'),
  layer: document.querySelector('.mode-layer'),
  btn: document.querySelector('.mode-button'),
};
